import { useEffect } from "react";
import { CallsOutcomeItem } from "../models/CallsAnalytics";

const COLORS = ["--bs-success", "--bs-warning", "--bs-danger", "--bs-gray-500"];
const HEX_FALLBACK = ["#50cd89", "#ffc700", "#f1416c", "#99a1b7"];

export default function CallOutcomesDonut({ outcomes }: { outcomes?: CallsOutcomeItem[] }) {

    useEffect(() => {
        if (!outcomes || outcomes.length === 0) return;
        const KTUtil = (window as any).KTUtil;
        const create = (window as any).createCircleChart;
        if (!KTUtil || !create) return;

        const colors = COLORS.map(v => KTUtil.getCssVariableValue(v));
        create("call-outcomes-donut", outcomes.map(o => o.count), colors);
    }, [outcomes]);

    const total = (outcomes ?? []).reduce((a, b) => a + b.count, 0);

    return (
        <div className="d-flex align-items-center flex-wrap">
            <div id="call-outcomes-donut" data-kt-size="150" data-kt-line="16" />
            <div className="ms-auto flex-grow-1 ps-4" style={{ minWidth: 160 }}>
                {
                    (outcomes ?? []).map((o, i) => (
                        <div key={o.name} className="d-flex align-items-center my-2">
                            <span style={{
                                width: 10, height: 10, borderRadius: "50%", display: "inline-block",
                                marginRight: 8, backgroundColor: HEX_FALLBACK[i % HEX_FALLBACK.length]
                            }} />
                            <span className="text-gray-600 flex-grow-1 fs-7">{o.name}</span>
                            <span className="fw-bold text-gray-800 fs-7">{o.count}</span>
                        </div>
                    ))
                }
                <div className="separator separator-dashed my-2"></div>
                <div className="d-flex align-items-center">
                    <span className="text-gray-500 flex-grow-1 fs-8 text-uppercase fw-bold">Total</span>
                    <span className="fw-bolder text-gray-800 fs-7">{total}</span>
                </div>
            </div>
        </div>
    );
}
